import { useQuery } from '@tanstack/react-query'
import i from 'i18next'

import { BadgeNotifications } from '~/components/BadgeNotifications'
import { getAccountId } from '~/helpers'
import { useAppInfo } from '~/hooks/useAppInfo'
import useQueryParams from '~/hooks/useQuery'
import Tabs from '~/modules/retailMedia/components/Tabs'
import { useAllowOffsiteBriefingCampaign } from '~/modules/retailMedia/hooks/useAllowOffsiteBriefingCampaign'
import {
  countOffsiteAdvertiserReviewKey,
  countOffsiteAdvertiserReviewService
} from '~/modules/retailMedia/services/campaign/offsite-advertiser-review'

const AdvertiserDashboardTabs: React.FC = () => {
  const { isWhiteLabel } = useAppInfo()

  const query = useQueryParams()
  const id = query.get('rmid')

  const {
    enabled: allowOffsiteBriefingCampaign,
    publisherId,
    homeInbox,
    canFetchQueue
  } = useAllowOffsiteBriefingCampaign()
  const scopedInbox = allowOffsiteBriefingCampaign && !!publisherId

  const { data: offsiteReview, isError: offsiteReviewCountFailed } = useQuery({
    enabled: canFetchQueue,
    // Conta na key: o QueryClient sobrevive à troca de conta. Ver o gate.
    queryKey: [
      countOffsiteAdvertiserReviewKey,
      getAccountId(),
      publisherId ?? 'home'
    ],
    queryFn: () =>
      countOffsiteAdvertiserReviewService(
        publisherId ? { publisher_id: publisherId } : {}
      )
  })

  const showOffsiteReviewTab =
    scopedInbox ||
    (homeInbox &&
      !offsiteReviewCountFailed &&
      offsiteReview?.available === true)

  const publisherTab = {
    to: '/retail-media/publishers',
    label: i.t('rm:mainTabs.publishers')
  }

  const linkParam = id ? `?rmid=${id}` : ''

  const offsiteReviewTab = {
    to: `/retail-media/campaigns/offsite-review${linkParam}`,
    label: i.t('rm:mainTabs.offsiteCampaignReview'),
    // A fila é o único acesso à revisão, então o badge fica visível mesmo em
    // zero. Em erro cai para zero para não exibir um total vencido.
    iconRight: (
      <BadgeNotifications>
        {offsiteReviewCountFailed ? 0 : (offsiteReview?.count ?? 0)}
      </BadgeNotifications>
    )
  }

  const tabs = [
    !isWhiteLabel && !id ? publisherTab : null,
    {
      to: `/retail-media/campaigns${linkParam}`,
      label: i.t('rm:mainTabs.campaigns')
    },
    {
      to: `/retail-media/ads${linkParam}`,
      label: i.t('rm:mainTabs.ads')
    },
    allowOffsiteBriefingCampaign || showOffsiteReviewTab
      ? offsiteReviewTab
      : null
  ].filter(i => !!i)

  return <Tabs tabs={tabs} />
}

export default AdvertiserDashboardTabs
